module.exports = __webpack_public_path__ + "static/Apartmani-Mima-Sokobanja-16-10bced0935d2989716c6c457ff69e723.jpg";